<!-- The castLabs UI tab pattern as the library ships it: one radio per tab ahead of the list, labels
     pointing at them, and the panels (the app-cl-tab hosts, carrying cl-tab-content cl-tab-N) as
     their siblings. Switching, arrow-key navigation and the focus outline are the library's; the
     radios' checked state follows active(), so remembered and late-arriving tabs still win. -->
<div class="cl-tabs">
  @for (tab of tabs; track tab; let i = $index) {
    <input type="radio" class="cl-tab-{{ i + 1 }}" [id]="uid + '-' + (i + 1)" [name]="uid"
           [checked]="tab.active()" (click)="confirmTab(tab)" (change)="selectTab(tab)">
  }
  <ul>
    @for (tab of tabs; track tab; let i = $index) {
      <li class="cl-tab-{{ i + 1 }}"><label [for]="uid + '-' + (i + 1)">{{ tab.tab_title }}</label></li>
    }
  </ul>
  <ng-content></ng-content>
</div>
